import * as types from './types';
import { getOperationTypeId } from '../../utils/getOperationTypeId.js';
import { isServiceError } from '../../utils/errorCodes';

const initialState = {
  formValues: {
    operationType: [],
    propertyType: '',
    propertySubType: null,
    propertyTypeName: ''
  },
  propertyTypesMostUsedOptions: [],
  propertyTypeOptions: [],
  propertyTypesError: false,
  propertyTypesLoading: false,
  propertyTypesCompleted: false,

  propertySubTypeOptions: [],
  propertySubTypeOptionsError: false,
  propertySubTypeOptionsLoading: false,
  propertySubTypeOptionsCompleted: false,

  formValuesError: false,
  formValuesLoading: false,
  formValuesCompleted: false
};

function stepMainReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PROPERTY_TYPE:
      return { ...state, propertyTypesLoading: true, propertyTypesError: false };
    case types.GET_PROPERTY_TYPE_FAILED:
      return {
        ...state,
        propertyTypesLoading: false,
        propertyTypesError: isServiceError(action?.payload?.status)
      };
    case types.GET_PROPERTY_TYPE_COMPLETED:
      return {
        ...state,
        propertyTypesMostUsedOptions: action.payload.realEstateTypeMostUsed || [],
        propertyTypeOptions: action.payload.realEstateTypes || [],
        propertyTypesLoading: false,
        propertyTypesCompleted: true
      };

    case types.GET_FORM_VALUES:
      return { ...state, formValuesLoading: true, formValuesError: false };
    case types.GET_FORM_VALUES_COMPLETED:
      return {
        ...state,
        formValues: {
          operationType: getOperationTypeId(action.payload.price_operation_type),
          propertyType: action.payload.real_estate_type_id,
          propertyTypeName: action.payload.real_estate_type_name,
          propertySubType: action.payload.real_estate_sub_type_id || null,
          propertySubTypeName: action.payload.real_estate_sub_type_name || ''
        },
        formValuesLoading: false,
        formValuesCompleted: true
      };
    case types.GET_FORM_VALUES_FAILED:
      return {
        ...state,
        formValuesLoading: false,
        formValuesError: isServiceError(action?.payload?.status)
      };

    case types.RESET_INFO:
      return {
        ...initialState
      };

    case types.GET_SUBPROPERTY_TYPE:
      return { ...state, propertySubTypeOptionsLoading: true, propertySubTypeOptionsError: false };
    case types.GET_SUBPROPERTY_TYPE_COMPLETED:
      return {
        ...state,
        propertySubTypeOptions: action.payload.realEstateSubTypes || [],
        propertySubTypeOptionsLoading: false,
        propertySubTypeOptionsCompleted: true
      };
    case types.GET_SUBPROPERTY_TYPE_FAILED:
      return {
        ...state,
        propertySubTypeOptionsLoading: false,
        propertySubTypeOptionsError: isServiceError(action?.payload?.status),
        propertySubTypeOptionsCompleted: true
      };

    default:
      return state;
  }
}

export { stepMainReducer };
